import API from 'services/API';

export default function updateData() {
  return API.request({
    method: 'POST',
    url: '/taxpayer/updateFacets',
  });
}
